'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = require('reselect');

var _getAvailabilityOfficeHoursWillReturnMessage = require('../../availability/selectors/getAvailabilityOfficeHoursWillReturnMessage');

var _getThreadCanAddAvailabilityMessage = require('../../availability/selectors/getThreadCanAddAvailabilityMessage');

var getShouldShowOfficeHoursEmailCaptureMessage = (0, _reselect.createSelector)([_getThreadCanAddAvailabilityMessage.getThreadCanAddAvailabilityMessage, _getAvailabilityOfficeHoursWillReturnMessage.getAvailabilityOfficeHoursWillReturnMessage], function (shouldDisplayResponseTime, officeHoursMessage) {
  return !!(shouldDisplayResponseTime && officeHoursMessage);
});

exports.default = getShouldShowOfficeHoursEmailCaptureMessage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/email-capture/selectors/getShouldShowOfficeHoursEmailCaptureMessage.js
// module id = 319
// module chunks = 2 3